import React, { useState, useEffect, useRef  } from 'react';
import { Snackbar, Alert } from '@mui/material';
import Sidebar from './Sidebar';
import WorkflowList from '../../workflow/WorkflowList';
import Tabs from './Tabs';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { deleteWorkflow } from '../services/homeService';
import { useWorkflows } from '../hooks/useHome';
import Header from '../../../components/common/Header/Header';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AUTH_SDK_MODULES, AUTH_SDK } from '../../../constants/appConstants';
import { checkPermission } from '../../../PolicyMaker/cdgAuthInitializer';
import cdgAuthInitializer from '../../../PolicyMaker/cdgAuthInitializer';

import './home.css';
import { CUSTOMER_ID } from '../../../constants/companyConfig';

const Home = () => {
  const { token, handleLogout } = useAuth();
  const [isAllowed, setIsAllowed] = useState(false);
  const navigate = useNavigate();
  const { workflows, setDeleteStatus, setWorkflows } = useWorkflows(
    token,
    handleLogout
  );
  const [activeTab, setActiveTab] = useState('Workflows');
  const initializedRef = useRef(false);
    useEffect(() => {
    getAuthSDK(CUSTOMER_ID, token);
  }, [CUSTOMER_ID, token]);

  // Snackbar state
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

const getAuthSDK = async (CUSTOMER_ID, token) => {
  if (CUSTOMER_ID && token) {
    initializedRef.current = true;  
    return await initializeCdgAuthConfig(token); // return boolean
  }
}

const initializeCdgAuthConfig = async (token) => {
  await cdgAuthInitializer(token).cdgAuthConfig();
  return await addRefLinks(token); // return boolean
};

const addRefLinks = async (token) => {
  const permissionGranted = await checkPermission(
      token,
      AUTH_SDK_MODULES?.[0].module,
      AUTH_SDK_MODULES?.[0].actions?.[0].name
  );
  setIsAllowed(permissionGranted); // still update state for UI
  return permissionGranted;         // return value for caller
};


  // Close Snackbar
  const handleSnackbarClose = () => setSnackbarOpen(false);

  // Utility to show Snackbar
  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleWorkflowClick = (workflow) => {
    navigate(`/workflow/${workflow.id}`, {
      state: {
        workflow: workflow.workflow,
        workflowId: workflow.id,
        workflowName: workflow.workflow_name,
      },
    });
  };

  const handleDeleteWorkflow = async (workflowId) => {
    if (await deleteWorkflow(workflowId, token)) {
      setWorkflows(workflows.filter((wf) => wf.id !== workflowId));

      setSnackbarMessage(`Workflow deleted successfully!`);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } else {
      setSnackbarMessage(`Failed to delete workflow.`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };
  const handleToggle = async (workflow) => {
    try {
      const payload = {
        workflow_name: workflow.workflow_name,
        workflow_status:
          workflow.workflow_status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
      };
      const url = `${process.env.REACT_APP_BASE_URL}/workflows/update/${workflow.id}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const updatedWorkflow = await response.json();
        if (updatedWorkflow.error) {
          setSnackbarMessage(updatedWorkflow.error);
          setSnackbarSeverity('error');
        } else {
          setWorkflows((prevWorkflows) =>
            prevWorkflows.map((w) =>
              w.id === workflow.id
                ? { ...w, workflow_status: payload.workflow_status }
                : w
            )
          );
          setSnackbarMessage('Workflow status updated successfully!');
          setSnackbarSeverity('success');
        }
      } else {
        setSnackbarMessage('Failed to update workflow status.');
        setSnackbarSeverity('error');
      }
    } catch (error) {
      setSnackbarMessage('An error occurred while updating workflow status.');
      setSnackbarSeverity('error');
      console.error('Error updating workflow:', error);
    } finally {
      setSnackbarOpen(true);
    }
  };

  const renderContent = () => {
    if (activeTab === 'Workflows') {
      return (
        <>
          {/* <WorkflowFilter filters={filters} setFilters={setFilters} /> */}
          <WorkflowList
            workflows={workflows}
            handleWorkflowClick={handleWorkflowClick}
            handleDeleteWorkflow={handleDeleteWorkflow}
            setWorkflows={setWorkflows}
            isAllowed={isAllowed}
            getAuthSDK={() => getAuthSDK(CUSTOMER_ID, token)}
          />
        </>
      );
    }
    // Handling for other tabs can be added here similarly
  };

  return (
    <div>
      <>
      <Header />

      <div className="home">
        {/* <Tabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}
        <Sidebar active={'home'} isAllowed={isAllowed} getAuthSDK={() => getAuthSDK(CUSTOMER_ID, token)}/>
        <div className="home-content">
          {renderContent()}
          {/* Snackbar */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity={snackbarSeverity}
              sx={{ width: '100%' }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      </div>
      </>
      <ToastContainer position="top-right"/>
    </div>
    // <div className={styles.container}>
    //   <Sidebar />
    //   <div className={styles.content}>
    //     {/* <Tabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}
    //     {activeTab === 'Workflows' && <WorkflowList workflows={workflows} handleWorkflowClick={handleWorkflowClick} handleDeleteWorkflow={handleDeleteWorkflow} handleToggle={handleToggle}/>}
    //     <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
    //       <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>{snackbar.message}</Alert>
    //     </Snackbar>
    //   </div>
    // </div>
  );
};

export default Home;
